<template>
    <Modal @modal:dismiss="$emit('dismiss')" class="modal-rattachement-message">
        <h3 slot="header">{{ header }}</h3>
        <div slot="body">{{ body }}</div>
        <div slot="error">{{ error }}</div>
        <div slot="footer">{{ footer }}</div>
    </Modal>
</template>

<script>
import Modal from './../Modal';

export default {
    props: ['header', 'body', 'error', 'footer'],
    components: {
        Modal,
    },
};
</script>

<style lang="scss"></style>
